<template>
  <el-container>
    <el-header>
      <div class="topFixed">
        <img class="img" src="../assets/logo144.jpg" alt="" />
        <div class="title">首页</div>
      </div>
    </el-header>
    <el-main style="margin-top: 50px">
      <el-carousel :height="bannerHeight + 'px'" type="card">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <h3 class="small">
            <img :src="item.url" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
      <h2 style="margin-top: 50px">近期热卖</h2>
      <div class="product-list">
        <div
          class="product-item"
          v-for="(item, index) in productList"
          :key="index"
        >
          <img class="product-img" :src="item.url" alt="" />
          <h5>{{ item.name }}</h5>
        </div>
      </div>
      <div class="app-detail">
         <img class="appLogo" src="../assets/logo144.jpg" alt="">
        <div class="app-text">
          <p>拔河网电动车配件平台,致力于更好的服务电动车配件批发商</p>
          <p>把控风险，和谐共生，网罗天下</p>
          </div class="app-text">
       
      </div>
      <div class="app-list">
        <div
          class="app-item"
          v-for="(item, index) in appList"
          :key="index"
        >
          <img class="app-img" :src="item.url" alt="" />
         
        </div>
      </div>
      
      <div class="codeBox">
        <div class="left">
          <h5>关注公众号</h5>
          <img src="../assets/gzh.jpg" alt="" />
        </div>
        <div class="right">
          <h5>下载APP（安卓版）</h5>
          <div class="imgBox">
            <img class="appImg" src="../assets/app.png" alt="" />
          </div>
        </div>
      </div>
    </el-main>
    <!-- <el-footer>
      <img class="footer" src="../assets/footer.png" alt="" />
    </el-footer> -->
    <!-- <img class="footer" src="../assets/footer.png" alt="" /> -->
    <div class="footer">
      <div class="top">
        <div>鲁ICP备2021039168号-2</div>
        <div>|</div>
        <div>联系地址：山东省济南市天桥区丁太鲁大街828号</div>
        <div>|</div>
        <div>联系方式：17077471234</div>
      </div>
      <div class="bottom">
        ©2018-2023 云分达 版权所有 并保留所有权利
      </div>
    </div>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      bannerList: [
        {
          url: require("../assets/banner1.jpg"),
        },
        {
          url: require("../assets/banner2.jpg"),
        },
        {
          url: require("../assets/banner3.jpg"),
        },
      ],
      productList: [
        {
          url: require("../assets/p1.jpg"),
          name: "苏浦士毂闸",
        },
        {
          url: require("../assets/p2.jpg"),
          name: "苏浦士下泵",
        },
        {
          url: require("../assets/p3.jpg"),
          name: "苏浦士油管",
        },
        {
          url: require("../assets/p4.jpg"),
          name: "苏浦士转把",
        },
      ],
      appList: [
        {
          url: require("../assets/y1.png"),
        
        },
        {
          url: require("../assets/y2.png"),
          
        },
        {
          url: require("../assets/y3.png"),
         
        }

      ],
      // 图片父容器高度
      bannerHeight: 1000,
      // 浏览器宽度
      screenWidth: 0,
    };
  },
  methods: {
    setSize: function () {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (600 / 1920) * this.screenWidth;
    },
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.main {
  width: 100%;
  height: 100%;
}
.topFixed {
  background: #fff;
  backdrop-filter: blur(3px);
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin: 0 aut0;
}
.img {
  width: 80px;
  height: 80px;
  margin-left: 100px;
}
.title {
  width: 50px;
  font-weight: bold;
  font-size: 20px;
  border-bottom: 4px solid hsl(29, 74%, 44%);
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
img {
  /*设置图片宽度和浏览器宽度一致*/
  width: 100%;
  height: inherit;
}
.product-list {
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 50px;
}
.product-item {
  width: 200px;
  height: 200px;
  border-radius: 20px;
}
.app-text{
  width: 300px;
  height: 100px;
  display: block;
  text-align: center;
  line-height: 30px;
  /* padding-top: 50px; */
  font-weight: bold;
}
.app-detail{
  width: 800px;
   margin:0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.appLogo{
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}
.codeBox {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 80%;
  margin: 400px auto 0 auto;
}
.app-list {
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 50px;
}
.app-item {
  width: 400px;
  /* height: 200px; */
  border-radius: 20px;
}
.imgBox{
  padding:20px;
}
.appImg {
  width: 316px;
  /* height: 316px; */
}
.footer {
  height: 200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #475669;
  color: #ffffff;
}
.top{
  width: 800px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.bottom{
  width: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue